export default function PolicyStatementHalloween() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolicyStatementHalloween">
          <div className="custom-button-layout">
            <span>
              <i className="fa-solid fa-hat-wizard fa-2xl feature-icon af-icon"></i>
            </span>
            <b>
              Policy Statement:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <br />
              Halloween Trick-Or-Treat Activity
            </b>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span className="badge bg-danger">Halloween</span>
          </div>
        </button>
      </h2>
      <div id="collapsePolicyStatementHalloween" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">
          <p>
            <strong>Policy Statement: Halloween Trick-Or-Treat Activity</strong>
          </p>

          <p>
            It is the policy of the Mayor and Borough Council that all door-to-door trick-or-treat activity, in connection with Halloween, shall take place annually on October 31st until 8:00 p.m, for
            perpetuity (subject to the Chief of Police modifications.). All children under 16 years of age shall be accompanied by a responsible adult.
          </p>

          <strong>Tips for Motorists:</strong>
          <ul>
            <li>Obey speed limits;</li>
            <li>Watch for children walking along the road or who may run into the street;</li>
            <li>If you are going to a party, please remember to designate a sober driver.</li>
          </ul>
          <strong>Tips for Parents and Guardians:</strong>
          <ul>
            <li>Buy, or make brightly-colored, highly-visible costumes for children that do not interfere with a child's ability to see, hear or walk;</li>
            <li>Add strips of reflective tape to darker-colored costumes and trick-or-treat bags;</li>
            <li>Provide a flashlight or glow stick for children to carry;</li>
            <li>Always accompany children while they are trick-or-treating;</li>
            <li>Remind children to pay attention to their surroundings.</li>
          </ul>
          <strong>Tips for Children:</strong>
          <ul>
            <li>Walk instead of run when crossing streets;</li>
            <li>Look both ways for approaching cars before stepping off the curb;</li>
            <li>Walk on sidewalks whenever possible. </li>
          </ul>

          <p>
            Residents are cautioned not to permit anyone into their home unless they know the identity of such a person; conversely, children (and parents) are cautioned not to enter anyone's home
            unless they know the residents and then only if they have the permission of a parent or guardian. Children should bring all edibles to their parent (or guardian) before eating such items.
            Parents should carefully inspect all items given their children to insure such items are safe.
          </p>
          <p>The Mayor and Borough Council wish everyone a safe and happy Halloween holiday.</p>

          <a href="../docs/press/press-2026-halloween-policy-20261015165047.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Policy Statement: Halloween Trick-Or-Treat Activity [PDF, 1 page]
          </a>
        </div>
      </div>
    </div>
  );
}
